export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Heavy Equipment Instructor Atlas after purchasing?',
    a: ['You receive digital access to the complete material after your purchase is successfully completed.'],
  },
  {
    q: 'Do I need to be an experienced heavy equipment instructor?',
    a: [
      'The system covers foundational and more advanced educational topics. It is intended for instructors and professionals involved in machinery training, who should use the material according to their qualifications and experience.',
    ],
  },
  {
    q: 'Is this system suitable for technical training centers?',
    a: [
      'Yes. The resources are designed to support classroom training in industrial education, vocational training and professional workplace instruction.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'The six main volumes focus on visual equipment references, technical diagrams, machinery illustrations, comparisons and training scenarios. The five bonus manuals provide additional written resources.',
    ],
  },
  {
    q: 'Does it include ready-to-use training material?',
    a: [
      'Yes. The system includes instructor-oriented activities, equipment identification challenges, workplace scenarios and assessment resources.',
    ],
  },
  {
    q: 'Does it cover beginner and advanced subjects?',
    a: [
      'Yes. It includes machinery fundamentals, component identification, technical concepts and more complex workplace hazard-recognition activities.',
    ],
  },
  {
    q: 'Can machinery operators use this system?',
    a: [
      'Yes, as supplementary educational reference material. It does not replace required operator instruction, supervised practical training or equipment-specific guidance.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. Your purchase includes all six specialized machinery training atlases.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. All five professional instructor bonuses are included with the complete package.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. The product contains digital PDF training materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. Heavy Equipment Instructor Atlas is provided in English.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['No. The training resources are delivered in PDF format, not editable source files.'],
  },
  {
    q: 'Does this replace official machinery training or operator certification?',
    a: [
      'No. This is a professional educational-resource system. It does not provide operator certification or replace mandatory equipment-specific training, practical evaluation, manufacturer documentation or applicable safety regulations.',
    ],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. You pay once to access the complete package. There is no recurring subscription.'],
  },
]
